import DesignEmailModal from './DesignEmailModal';

export default DesignEmailModal;
